import { useMediaQuery, useTheme } from '@mui/material';

import ResetPageDesktop from 'src/components/account/PasswordResetPage/ResetPageDesktop';
import ResetPageMobile from 'src/components/account/PasswordResetPage/ResetPageMobile';

const PasswordResetPage = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  return isDesktop ? <ResetPageDesktop /> : <ResetPageMobile />;
};

export default PasswordResetPage;
